/**
 * landingpage/js/leaderboard-ui.js v2.0 - Truncation Limit Increased
 * Gestione dell'interfaccia utente della classifica nella landing page.
 * MODIFICATO: Aumentato limite troncamento nickname a 20 caratteri.
 * MANTIENE: Espansione Condizionale Leaderboard v1.9, caching, etc.
 */

window.LandingPageLeaderboardUI = (function() {
    // Riferimenti agli elementi del DOM
    let leaderboardContainer;
    let leaderboardBody;
    let leaderboardArrow;
    let leaderboardToggleButton; // Pulsante accanto a GIOCA ORA
    let leaderboardTitle;

    const maxScoresToLoad = 10;

    // Stato interno
    let isLoading = false;
    let currentView = 'weekly';
    let weeklyScores = null;
    let allTimeScores = null;
    let scoresData = []; // Mantiene i dati attualmente visualizzati per riferimento

    /** Inizializza il modulo */
    function initialize() {
        if (window.LandingPageLeaderboardUI.initialized) return;
        window.LandingPageLeaderboardUI.initialized = true;

        console.log('[LBS UI Landing] Initializing (v2.0 - Truncation 20)...');
        leaderboardContainer = document.getElementById('leaderboard-container');
        leaderboardBody = document.getElementById('leaderboard-body');
        leaderboardArrow = document.getElementById('leaderboard-arrow');
        leaderboardToggleButton = document.getElementById('leaderboard-button'); // Riferimento corretto
        leaderboardTitle = document.getElementById('leaderboard-title');

        if (!leaderboardContainer || !leaderboardBody || !leaderboardArrow || !leaderboardToggleButton || !leaderboardTitle) {
            console.error("[LBS UI Landing] Errore Critico: Elementi UI leaderboard mancanti!");
            if (leaderboardToggleButton) leaderboardToggleButton.disabled = true;
            return;
        }

        // Imposta stato iniziale UI
        leaderboardTitle.textContent = "CLASSIFICA SETTIMANALE";
        leaderboardToggleButton.innerHTML = "CLASSIFICA<br>ALL-TIME";
        leaderboardToggleButton.classList.add('two-lines');
        leaderboardToggleButton.style.textAlign = 'center';
        currentView = 'weekly';
        leaderboardBody.innerHTML = '<tr><td colspan="3" style="text-align: center; padding: 20px;">In attesa di caricamento...</td></tr>';
        leaderboardContainer.classList.remove('leaderboard-expanded');
        leaderboardArrow.classList.remove('arrow-up', 'visible');
        leaderboardContainer.style.cursor = 'default';

        setupEventListeners();

        console.log('[LBS UI Landing] Initialized (v2.0).');
    }

    /** Attacca gli event listener statici (toggle vista) */
    function setupEventListeners() {
        console.log("[LBS UI Landing] Setup Event Listeners Statici (v2.0)...");
        const safeAddListener = (element, event, handler) => {
            if (element && document.body.contains(element)) {
                element.removeEventListener(event, handler);
                element.addEventListener(event, handler);
                return true;
            }
            return false;
        };

        if (!safeAddListener(leaderboardToggleButton, 'click', toggleLeaderboardView)) {
            console.warn("[LBS UI] Impossibile aggiungere listener a leaderboardToggleButton.");
        }

        // Listener per 'click' su leaderboardContainer gestito da renderLeaderboard.
        console.log("[LBS UI Landing] Event listeners statici configurati.");
    }

    /** Espande/Comprime la visualizzazione (chiamata solo se il listener è attivo) */
    function toggleLeaderboardExpansion(event) {
        if (!leaderboardContainer || !leaderboardArrow || !leaderboardToggleButton) return;
        if (event.target === leaderboardToggleButton || leaderboardToggleButton.contains(event.target)) {
            console.log("[LBS UI] Click su toggle vista ignorato per espansione.");
            return;
        }
        const isExpanded = leaderboardContainer.classList.toggle('leaderboard-expanded');
        leaderboardArrow.classList.toggle('arrow-up', isExpanded);
        console.log(`[LBS UI] Leaderboard expansion toggled via container: ${isExpanded}`);
    }

    /** Cambia la vista tra Classifica Settimanale e All-Time */
    function toggleLeaderboardView() {
        if (isLoading || !leaderboardTitle || !leaderboardToggleButton) return;
        const nextView = (currentView === 'weekly') ? 'alltime' : 'weekly';
        console.log(`[LBS UI Toggle] Switching view from ${currentView} to ${nextView}`);
        currentView = nextView;
        leaderboardTitle.textContent = (currentView === 'weekly') ? "CLASSIFICA SETTIMANALE" : "CLASSIFICA ALL-TIME";
        if (currentView === 'weekly') { leaderboardToggleButton.innerHTML = "CLASSIFICA<br>ALL-TIME"; }
        else { leaderboardToggleButton.innerHTML = "CLASSIFICA<br>SETTIMANALE"; }
        leaderboardToggleButton.classList.add('two-lines');
        leaderboardToggleButton.style.textAlign = 'center';
        const cachedData = (currentView === 'weekly') ? weeklyScores : allTimeScores;
        if (cachedData !== null) { renderLeaderboard(cachedData); }
        else { loadLeaderboard(currentView); }
    }

    /** Carica i punteggi dalla classifica specificata */
    async function loadLeaderboard(type) {
        // ... (invariato v1.9) ...
        if (isLoading) { console.warn(`[LBS UI Load ${type}] Caricamento già in corso.`); return; }
        const managerExists = window.leaderboardManager;
        const methodName = type === 'weekly' ? 'getWeeklyTopScores' : 'getAllTimeTopScores';
        const methodExists = typeof window.leaderboardManager?.[methodName] === 'function';
        if (!managerExists || !methodExists) { console.error(`[LBS UI Load ${type}] Errore FATALE: leaderboardManager o metodo ${methodName} mancante!`); if (leaderboardBody) leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FF6666;">Errore Manager (${type})</td></tr>`; if (leaderboardArrow) leaderboardArrow.classList.remove('visible', 'arrow-up'); return; }
        isLoading = true; console.log(`[LBS UI Load ${type}] Avvio caricamento...`); if (leaderboardBody) { leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px;">Caricamento ${type === 'weekly' ? 'settimanale' : 'all-time'}...</td></tr>`; } if (leaderboardArrow) leaderboardArrow.classList.remove('visible', 'arrow-up');
        try {
            let scores = []; scores = await window.leaderboardManager[methodName](maxScoresToLoad); scoresData = scores || [];
            if (type === 'weekly') { weeklyScores = scoresData; } else { allTimeScores = scoresData; }
            console.log(`[LBS UI Load ${type}] Punteggi ricevuti:`, scoresData.length);
            if (currentView === type) { renderLeaderboard(scoresData); }
            else { console.log(`[LBS UI Load ${type}] Dati caricati, ma vista cambiata a ${currentView}. Non renderizzo.`); updateExpandability(scoresData.length); }
        } catch (error) { console.error(`[LBS UI Load ${type}] Errore durante il processo di caricamento classifica:`, error); scoresData = []; if (currentView === type && leaderboardBody) { leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FF6666;">Errore caricamento ${type === 'weekly' ? 'settimanale' : 'all-time'}</td></tr>`; renderLeaderboard([]); } }
        finally { isLoading = false; console.log(`[LBS UI Load ${type}] Caricamento terminato.`); }
    }

    /** Renderizza la classifica e aggiorna lo stato di espandibilità. */
    function renderLeaderboard(scores) {
        if (!leaderboardBody || !leaderboardContainer || !leaderboardArrow) { console.error('[LBS UI Render] Elementi UI non trovati per render.'); return; }
        console.log(`[LBS UI Render] Renderizzo ${scores.length} punteggi per vista ${currentView}`);
        leaderboardBody.innerHTML = '';

        if (!Array.isArray(scores) || scores.length === 0) {
            leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px;">Nessun punteggio ${currentView === 'weekly' ? 'questa settimana' : 'registrato'}.</td></tr>`;
        } else {
            scores.forEach((score, index) => {
                const row = document.createElement('tr');
                const rankClass = index < 3 ? `rank-${index + 1}` : '';
                // ** MODIFICATO: Limite troncamento a 20 caratteri **
                const displayName = score.name ? escapeHtml(score.name.substring(0, 20)) : 'Giocatore';
                const displayScore = formatScore(score.score);
                const displayPosition = score.position || (index + 1);
                row.innerHTML = ` <td class="${rankClass}">${displayPosition}</td> <td>${displayName}</td> <td>${displayScore}</td> `;
                leaderboardBody.appendChild(row);
            });
        }

        // Resetta stato espansione e aggiorna
        leaderboardContainer.classList.remove('leaderboard-expanded');
        leaderboardArrow.classList.remove('arrow-up');
        updateExpandability(scores.length);

        console.log('[LBS UI Render] Classifica aggiornata.');
    }

    /** Aggiorna visibilità freccia e listener click container in base al numero di score */
    function updateExpandability(scoreCount) {
        // ... (invariato v1.9) ...
        if (!leaderboardContainer || !leaderboardArrow) return;
        leaderboardContainer.removeEventListener('click', toggleLeaderboardExpansion);
        if (scoreCount > 3) { leaderboardArrow.classList.add('visible'); leaderboardContainer.addEventListener('click', toggleLeaderboardExpansion); leaderboardContainer.style.cursor = 'pointer'; }
        else { leaderboardArrow.classList.remove('visible'); leaderboardContainer.style.cursor = 'default'; }
    }

    /** Funzione helper per l'escape di HTML. */
    function escapeHtml(unsafe) { /* ... (invariato v1.9) ... */ if (unsafe === null || typeof unsafe === 'undefined') return ""; const str = String(unsafe); return str.replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">").replace(/"/g, "&quot;").replace(/'/g, "&#39;"); }
    /** Formatta i punteggi */
    function formatScore(score) { /* ... (invariato v1.9) ... */ if (typeof score !== 'number' || isNaN(score)) return '0'; return score.toLocaleString('it-IT'); }

    // API Pubblica
    return {
        initialize: initialize,
        loadLeaderboard: loadLeaderboard
    };
})();

// --- END OF FILE public/landingpage/js/leaderboard-ui.js ---